import {Severity} from '@sentry/browser';

export default {
  methods: {
    isOrderFormExpired() {
      if (!this.journeyConfig.expirationRedirectType ||
        !this.journeyConfig.expirationFrom ||
        !this.journeyConfig.expirationTo) {
        return false;
      }

      // Fix Date
      this.journeyConfig.expirationRedirectType = this.journeyConfig.expirationRedirectType.replace(' ', 'T');
      this.journeyConfig.expirationFrom = this.journeyConfig.expirationFrom.replace(' ', 'T');
      this.journeyConfig.expirationTo = this.journeyConfig.expirationTo.replace(' ', 'T');

      // Retrieve expiration config
      const expType = this.journeyConfig.expirationRedirectType;
      const expFrom = (new Date(this.journeyConfig.expirationFrom)).getTime();
      const expTo = (new Date(this.journeyConfig.expirationTo)).getTime();
      const now = (new Date()).getTime();

      // Check if we are on expiration pageType
      const path = window.location.pathname.split('/');

      // If we are currently in the expiration date range
      if (!path.includes('expired.html') && expFrom <= now && now <= expTo) {
        let url = '';
        // Internal --> redirect to expired.html
        if (expType === 'internal') {
          path[path.length - 1] = 'expired.html';
          url = window.location.origin + path.join('/');
        } else {
          // External --> redirect to URL
          url = this.journeyConfig.expirationRedirectUrl;
          if (!url) {
            this.sendSentryLog(
              Severity.Fatal,
              'Unable to retrieve expiration redirect URL',
              {journeyConfig: this.journeyConfig});
            return false;
          }
        }

        window.location = this.appendQueryParamsBeforeRedirection(url);
        return true;
      }

      return false;
    }
  }
};



// WEBPACK FOOTER //
// ./src/multiple/mixins/expiration.js